import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Hero from './components/Hero';
import FeaturedProducts from './components/FeaturedProducts';
import AnimationsShowcase from './components/AnimationsShowcase';
import AboutUs from './components/AboutUs';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import NewsletterSection from '@/pages/home/components/NewsletterSection';

export default function HomePage() {
  useEffect(() => {
    document.title = 'AiShopio Dubai - Online Shopping Beauty, Kitchen & Electronics UAE';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'AiShopio Dubai: Shop premium beauty, kitchen, health & electronics products online. Free UAE delivery on orders over AED 200. Cash on delivery. 10,000+ happy customers across all 7 Emirates.');

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'AiShopio',
        url: siteUrl,
        potentialAction: {
          '@type': 'SearchAction',
          target: { '@type': 'EntryPoint', urlTemplate: `${siteUrl}/search?q={search_term_string}` },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'AiShopio',
        url: siteUrl,
        logo: `${siteUrl}/favicon.png`,
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+971-50-000-0000',
          contactType: 'customer service',
          areaServed: 'AE',
          availableLanguage: ['English', 'Arabic'],
        },
        sameAs: [],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        name: 'AiShopio Dubai',
        description: 'Premium online shopping store in Dubai offering beauty, kitchen, health and electronics products with free UAE delivery.',
        url: siteUrl,
        telephone: '+971-50-000-0000',
        email: 'hello@aishopio.ae',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Dubai',
          addressCountry: 'AE',
        },
        geo: { '@type': 'GeoCoordinates', latitude: 25.2048, longitude: 55.2708 },
        openingHoursSpecification: [
          { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Saturday','Sunday','Monday','Tuesday','Wednesday','Thursday'], opens: '09:00', closes: '21:00' },
        ],
        priceRange: 'AED',
        currenciesAccepted: 'AED',
        paymentAccepted: 'Cash, Credit Card',
        areaServed: { '@type': 'Country', name: 'United Arab Emirates' },
      },
    ];

    const existingScripts = document.querySelectorAll('script[data-schema="home"]');
    existingScripts.forEach(s => s.remove());

    schemas.forEach((schema, i) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'home');
      script.setAttribute('data-schema-index', String(i));
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-schema="home"]').forEach(s => s.remove());
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <FeaturedProducts />
      <AnimationsShowcase />
      <AboutUs />
      <Testimonials />
      <NewsletterSection />
      <Footer />
    </div>
  );
}